// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__f0hVf","disabled":"FileBtn_disabled__rhthb","warn":"FileBtn_warn__3svRo","fade":"FileBtn_fade__3q4cb"};